var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-header"},[_c('advanced-filters',{staticClass:"advanced-filters",class:{ 'disabled': !_vm.canUseFilters },attrs:{"disabled":!_vm.canUseFilters},on:{"filter-calls":_vm.filterCalls}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }